// Debug panel only: makes the backend see another client IP, the way a VPN reconnect or a network change would.
const STORAGE_KEY = 'tempedge:debug:ip';
const SIMULATED_IP = '203.0.113.7';

const isDebugBuild = () => process.env.REACT_APP_SHOW_TOKEN_INFO === 'true';

export const getDebugIp = () => {
  if (!isDebugBuild()) return null;
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch (error) {
    return null;
  }
};

/**
 * Turns the simulated IP on or off. When the storage is unavailable the simulation stays off.
 * @returns {boolean} Whether the simulation is on after the toggle.
 */
export const toggleDebugIp = () => {
  try {
    if (getDebugIp()) sessionStorage.removeItem(STORAGE_KEY);
    else sessionStorage.setItem(STORAGE_KEY, SIMULATED_IP);
  } catch (error) {
    return false;
  }

  return Boolean(getDebugIp());
};

// The backend reads the first X-Forwarded-For value as the client IP.
export const applyDebugIp = (headers) => {
  const debugIp = getDebugIp();
  if (debugIp) headers['X-Forwarded-For'] = debugIp;
  return headers;
};
